module.exports = __webpack_public_path__ + "media/images/icons/payment_methods/Sofort-2ef0cea74285ff7213c0e39cadcddc0f.svg";